<div class="container Unsubs">
  <div class="Unsubs_wrapper d-flex flex-column">
    <div class="Unsubs_wrapper_header">
      <h1>Unsubscribe</h1>
    </div>
    <div class="Unsubs_wrapper_body p-3 p-sm-5">
      <div *ngIf="status === 'loading'" class="Unsubs_wrapper_body_status">
        <p class="mb-0">Processing your request…</p>
      </div>
      <div
        *ngIf="status === 'success'"
        class="Unsubs_wrapper_body_status Unsubs_wrapper_body_status--success">
        <h5 class="mb-3">You're unsubscribed</h5>
        <p class="mb-0">{{ message }}</p>
      </div>
      <div
        *ngIf="status === 'error'"
        class="Unsubs_wrapper_body_status Unsubs_wrapper_body_status--error alert alert-danger mb-0">
        <h5 class="mb-3">Unable to unsubscribe</h5>
        <p class="mb-0">{{ message }}</p>
      </div>
    </div>
  </div>
</div>
